<template>
  <v-container :class="item.show ? '' : 'py-0'" fluid tag="section">
      <base-material-dialog
        title='客户查重'
        :dialog="item.show"
        @on-dialog-change='dialogChange'
        persistent
        max-width='400'
      >
        <template v-slot:content>
           <v-card class="px-5" elevation="0">
            <v-form ref="form" lazy-validation @submit.native.prevent>
              <v-row>
                <v-col cols="12">
                  <v-text-field label="客户名称"  @keydown="queryKeyDown()" filled rounded  dense :rules="required" v-model="form.name">
                    <template v-slot:append>
                      <v-btn fab small color="primary" :loading='loading' class="mt-n2 mr-n5" @click="repeat">
                        <v-icon dark>mdi-magnify</v-icon>
                      </v-btn>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
              <v-list v-if="result.length > 0">
                <template v-for="(item, index) in result">
                  <v-list-item :key="index" v-if="index < 5" class="px-1">
                    <v-list-item-content>
                      <v-card outlined class="pd-c-10">
                        <v-list-item-title v-html="item.name"></v-list-item-title>
                        <v-list-item-subtitle class="my-2">{{item.createTime | formatDate}}</v-list-item-subtitle>
                        <v-list-item-subtitle>
                          <span  v-for="(item, idx) in item.contactsPersonList" :key="idx">
                            <v-chip class="mr-1" small outlined>
                              {{item.name}}<v-icon right> mdi-account-outline </v-icon>
                            </v-chip>
                          </span>
                        </v-list-item-subtitle>
                        <v-row align="center" justify="end" v-if="item.poolStatus === 2">
                          <v-card-actions >
                            <v-btn outlined text @click="showGet(item)">捞取</v-btn>
                          </v-card-actions>
                        </v-row>
                      </v-card>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-list>
            </v-form>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text class="text--disabled" @click='item.show = false'>
                关闭
              </v-btn>
            </v-card-actions>
          </v-card>
        </template>
    </base-material-dialog>
    <v-dialog v-model="dialog" max-width="320">
      <v-card>
        <v-card-title class="text-h6">
          <v-icon color="warning">mdi-alert</v-icon>&nbsp;
          系统提示
        </v-card-title>
        <v-card-text>
          <div class="text-h6 pa-2">确定捞取客户吗？</div>
        </v-card-text>
        <v-card-actions class="justify-end p4-1">
          <v-btn text small color="blue" @click="dialog = false">取消</v-btn>
          <v-btn color="primary" :loading="loading" depressed small @click="save">
            确定
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import { repeat, get } from '@/api/customer/index.js'

  export default {
    name: 'CustomerRepeat',
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false
        })
      }
    },
    data() {
      return {
        dialog: false,
        loading: false,
        required: [
          value => !!value || '此项为必填项!'
        ],
        result: [],
        form: {
          id: '',
          name: '',
          like: 1
        }
      }
    },
    methods: {
      repeat () {
        if (this.$refs.form.validate()) {
          this.loading = true
          repeat(this.form).then(res => {
            if (res.status === 200) {
              this.result = res.data
            }
            this.loading = false
          })
        }
      },
      showGet (item) {
        this.form.id = item.id
        this.form.poolStatus = 1
        this.dialog = true
      },
      save () {
        this.loading = true
        get(this.form).then(res => {
          if (res.status === 200) {
            this.dialog = false
            this.repeat()
            this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
          }
          this.loading = false
        })
      },
      queryKeyDown () {
        if (window.event.keyCode === 13) {
          this.repeat()
        }
      },
      dialogChange (val) {
        this.item.show = val
        this.result = []
        this.form.name = ''
      }
    }
  }
</script>

<style lang="sass" scoped>
</style>
